// LIBRERIE/IMPORTS
import React from "react";

interface SubHeaderProps {
  title: string;
  isSeo: boolean;
}

const SubHeaderDefault: React.FC<SubHeaderProps> = ({ title, isSeo }) => {
  return (
    <div id="subHeader_default" className="bg-overlay-black-20">
      <div className="container">
        <div className="row align-items-center justify-content-center text-center">
          {isSeo ? (
            <h1 className="text-white">{title}</h1>
          ) : (
            <h2 className="asH1Title">{title}</h2>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubHeaderDefault;